// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'


import VideoPlayer from 'vue-video-player'
import VueAMap from 'vue-amap'
// import 'element-ui/lib/theme-chalk/index.css'
//import '@/styles/element-ui'// 饿了么自定义
import Share from 'vue-social-share'
import 'vue-social-share/dist/client.css';
Vue.use(Share)

import '../theme/index.css'// 饿了么自定义样式
import VueQriously from 'vue-qriously' // 二维码生成插件
import VueLazyLoad from 'vue-lazyload'//懒加载
// import ElementUI from 'element-ui'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import 'swiper/dist/css/swiper.css'
import '@/assets/css/common.css' // global css


Vue.use(VideoPlayer);
Vue.use(VueLazyLoad)
Vue.use(VueQriously)
Vue.use(VueAwesomeSwiper)
Vue.use(VueAMap)
Vue.config.productionTip = false

VueAMap.initAMapApiLoader({
  key: '9e03b8b66088be89d70667123f3ba5f4',
  plugin: ['AMap.Autocomplete', 
            'AMap.PlaceSearch', 
            'AMap.Scale', 
            'AMap.OverView', 
            'AMap.ToolBar', 
            'AMap.MapType', 
            'AMap.PolyEditor', 
            'AMap.CircleEditor', 
            'AMap.Geolocation',
            'AMap.Geocoder'
          ]
})
Vue.use(ELEMENT)
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js